<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center no-wrap">
          <MenuType :value="props.item.menuType" />
        </td>
        <td class="text-xs-center no-wrap">
          <AppPeriod
            :start="props.item.startDate"
            :end="props.item.endDate"
            is-date
          />
        </td>
        <td class="text-xs-center">
          <Status
            :status="props.item.requestStatus"
            with-color
            perspective="agency"
          />
        </td>
        <td class="text-xs-left">
          <pre>{{ props.item.reason }}</pre>
        </td>
        <td class="text-xs-center no-wrap">
          {{ props.item.requestAccountName }}
        </td>
        <td class="text-xs-center">
          <AppDateTime :value="props.item.requestTime" />
        </td>
      </template>
      <template slot="no-data">
        <div>登録されている申請履歴はありません</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Status from '@/components/Shared/Presentation/Request/Status'
import MenuType from '@/components/Shared/Presentation/Menu/MenuType'

export default {
  name: 'HistoryTable',
  components: { Status, MenuType },
  props: {
    currency: String,
    items: Array,
    loading: Boolean,
  },
  computed: {
    headers() {
      return [
        {
          text: 'ベースメニュー',
          value: 'menuType',
          align: 'center',
          sortable: false,
        },
        { text: '期間', value: 'period', align: 'center', sortable: false },
        {
          text: 'ステータス',
          value: 'requestStatus',
          align: 'center',
          sortable: false,
        },
        {
          text: '却下理由',
          value: 'reason',
          align: 'left',
          sortable: false,
        },
        {
          text: '申請者名',
          value: 'requestAccountName',
          align: 'center',
          sortable: false,
        },
        {
          text: '申請日時',
          value: 'requestTime',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
}
</script>
